import { render } from "./BaseWizardActions.vue?vue&type=template&id=62070258"
import script from "./BaseWizardActions.vue?vue&type=script&lang=js"
export * from "./BaseWizardActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__